export class Ease {
  /**
   * Linear
   */
  public static linear(k: number): number {
    return k;
  }

  /**
   * Quadratic easing in
   */
  public static inQuad(k: number): number {
    return k * k;
  }
  /**
   * Quadratic easing out
   */
  public static outQuad(k: number): number {
    return k * (2 - k);
  }

  /**
   * Quadratic easing in/out
   */
  public static inOutQuad(k: number): number {
    if (k < 0.5) {
      return k * k * 2;
    }
    return (k * (2 - k) - 0.5) * 2;
  }
}
